<div class="" clickOutside (clickOutside)="closeDropdown()">
    <div class="user-container flex items-center cursor-pointer rounded-md px-2 py-1 min-h-[44px]" (click)="toggleDropdown()">
        <div class="user-picture w-6 h-6 sm:w-8 sm:h-8 rounded-full mr-1 sm:mr-2 bg-cover bg-center flex-shrink-0"
            [style.background-image]="'url(' + currentLanguageObj.flagImage + ')'"></div>
        <div class="info-container text-sm sm:text-base" [ngClass]="textClass">{{ currentLanguageObj.name }}</div>
    </div>

    <div *ngIf="isDropdownOpen"
        class="language-dropdown absolute right-0 mt-1 bg-white rounded-md shadow-lg p-2 max-w-[200px] sm:max-w-md z-50">
        <div *ngFor="let language of languages"
            class="px-6 sm:px-12 language-option flex items-center justify-center p-2 hover:bg-gray-100 rounded cursor-pointer min-h-[44px] text-sm sm:text-base"
            (click)="selectLanguage(language)">
            <div>{{ getLocalizedName(language) }}</div>
        </div>
    </div>
</div>